import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';

import Cost from 'common/components/Cost';
import DialogListPicker from 'ondemand/components/DialogListPicker';
import DialogListSection from 'ondemand/components/DialogListSection';
import DialogListItem from 'ondemand/components/DialogListItem';
import {getDays, getTimes} from 'ondemand/utils/gtfs';

const restrictionText = service => {
  const restrictions = {
    riderRestricted: 'pre-approved',
    shibbolethRestricted: 'logged in with Shibboleth',
  };
  const restrictionStrings = _.filter(_.map(restrictions, (r, prop) => (service[prop] ? r : null)));
  return restrictionStrings.length ? `Riders must be ${restrictionStrings.join(' and ')}` : null;
};

const buildFareInfo = (service) => {
  if (service.fare_required) {
    if (service.fare_price) {
      return (
        <div data-id="fare-price"><Cost amount={service.fare_price} currencyCode="USD" /></div>
      );
    }
    return <div data-id="fare-required">Fare Required</div>;
  }
  return null;
};

const createServiceNode = (service, onServiceClick, serviceMessage, disabled = false) => {
  const restrictionNode = restrictionText(service);
  const secondaryText = (
    <div>
      <span>{`${getDays(service)}, ${getTimes(service)}`}</span>
      {
        disabled && serviceMessage &&
        (
          <div style={{fontStyle: 'italic', lineHeight: 1.5, marginTop: '.5em'}}>
            {serviceMessage}
          </div>
        )
      }
      <div style={{fontStyle: 'italic', lineHeight: 1.5}}>{restrictionNode}</div>
    </div>
  );
  return (
    <DialogListItem
      dataId={service.service_id}
      key={service.service_id}
      onClick={disabled ? null : () => onServiceClick(service)}
      primaryText={service.name}
      rightText={buildFareInfo(service)}
      secondaryText={secondaryText}
      secondaryTextLines={restrictionNode ? 2 : 1}
    />
  );
};

const ServicePickerModal = ({
  dataId,
  serviceMessage,
  availableServices,
  unavailableServices,
  onServiceClick,
  open,
}) => {
  const activeNodes = availableServices.map(service => createServiceNode(service, onServiceClick));
  const inactiveNodes = unavailableServices.map(service => {
    const message = service.currentException && service.currentException.removal &&
      service.currentException.message
      ? service.currentException.message
      : serviceMessage;
    return createServiceNode(service, onServiceClick, message, true);
  });
  const inactiveSection = inactiveNodes.length === 0
    ? null
    : <DialogListSection disabled title="Currently Not Available">
        {inactiveNodes}
      </DialogListSection>;

  return (
    <DialogListPicker open={open}>
      <div data-id={dataId} >
        <DialogListSection title="Select a Service" mainMenuLink>
          {activeNodes}
        </DialogListSection>
        {inactiveSection}
      </div>
    </DialogListPicker>
  );
};

ServicePickerModal.propTypes = {
  dataId: PropTypes.string,
  serviceMessage: PropTypes.string,
  availableServices: PropTypes.arrayOf(PropTypes.object).isRequired,
  unavailableServices: PropTypes.arrayOf(PropTypes.object).isRequired,
  onServiceClick: PropTypes.func,
  open: PropTypes.bool,
};

export default ServicePickerModal;



// WEBPACK FOOTER //
// ./src/ondemand/components/ServicePickerModal.js